const a = {
  enabled: !0,
  handlePrepend: !1
}, i = (t, s) => {
  const e = s || t.scrollHeight - t.clientHeight;
  typeof t.scroll == "function" ? t.scroll({ top: e }) : t.scrollTop = e;
}, o = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), c = (t, s) => {
  if (s.enabled === !1)
    return;
  if (s.handlePrepend === !1) {
    i(t);
    return;
  }
  const e = t.scrollTop === 0 && n.has(t) && t.scrollHeight - n.get(t);
  e && i(t, e), n.set(t, t.scrollHeight);
}, u = {
  mounted: (t, s) => {
    const e = { ...a, ...s.value };
    c(t, e);
  },
  /**
   * When the directive binding is updated we have to update our MutationObserver.
   * We disconnect the old MutationObserver (if it already exists in observers).
   * We then create and save a new MutationObserver with the new callback.
   */
  updated: (t, s) => {
    o.has(t) && o.get(t).disconnect();
    const e = { ...a, ...s.value }, l = () => {
      c(t, e);
    };
    c(t, e);
    const r = new MutationObserver(l);
    r.observe(t, { childList: !0, subtree: !0 }), o.set(t, r);
  }
}, d = {
  install: (t) => {
    t.directive("chat-scroll", u);
  }
};
export {
  d as default
};
